<!-- <div class="trapezio"></div>
<div class="trapezio2"></div>
<div class="block"></div> -->

<div id="wrapper" *ngIf="tab == 0">
  <form id="regForm" hidden style="width: 70%;">
    <div class="tab">
      <div class="intro-home">
        <div class="introduction">
          <img src="./assets/logo-previndus.png" class="img-logo" />
          <p class="intro-text" flex-direction="row">
            Preparado para tornar o sonho em realidade? Vamos juntos realizar a simulação e escolher a
            melhor forma de chegar lá!
          </p>
          <div>
            <h4 class="text-form-name">Qual o seu nome completo?</h4>
            <input id="inputP1" class="input-name" placeholder="Seu nome" name="fname" [(ngModel)]="nome"
              style="width: 100%;">
            <h6 style="color:#bababa; font-size: 16px; font-weight: 400; opacity: 0.9;" *ngIf="nome == ''">Preencha com
              seu
              nome</h6>
          </div>
          <button type="button" id="nextBtn" (click)="next()" *ngIf="nome != ''"
            style="width: 100%;"><b>COMEÇAR</b></button>
        </div>
        <img src="./assets/intro.png" class="img-introduction" />
      </div>
    </div>
  </form>
</div>

<div id="wrapper2" *ngIf="tab == 1">


  <form id="regForm" hidden style="width: 45%;">

    <div id="container-progress" style="margin-bottom: 16px">
      {{ProgressBar(8)}}
      <div id="myProgress">
        <div id="myBar"></div>
        <ul class="ul-icons">
          <li id="circle1" class=" tooltip">
            <span class="tooltiptext">Sobre Você</span>
          </li>
          <li id="circle2" class=" tooltip">
            <span class="tooltiptext">Sobre seu projeto</span>
          </li>
          <li id="circle3" class=" tooltip">
            <span class="tooltiptext">Resultado da simulação</span>
          </li>
        </ul>
      </div>
    </div>

    <div class="tab">
      <small class="etapas">Pergunta 2 de 8</small>


      <p class="description-step"><span class="nome-pessoa"></span>{{nome}}, informe os dados abaixo:</p>
      <p><input id="inputP2" class="myName" placeholder="Seu CPF" mask="000.000.000-00" (input)="checarCPF()"
          [(ngModel)]="cpf" name="fcpf">
      </p>
      <h6 style="color:#ff0000aa; margin-bottom: 8px; font-size: 16px; font-weight: 400; opacity: 0.9;"
        *ngIf="!cpfValid && cpf">
        Digite um CPF válido.
      </h6>
      <h6 style="color:#bababa; font-size: 16px; font-weight: 400; opacity: 0.9;" *ngIf="cpf == ''">Preencha com
        seu CPF</h6>

      <p><input id="inputP2" class="myName" placeholder="Seu email" (input)="checarEmail()" [(ngModel)]="email"
          name="femail">
      </p>
      <h6 style="color:#ff0000aa; margin-bottom: 8px; font-size: 16px; font-weight: 400; opacity: 0.9;"
        *ngIf="!emailValid && email">
        Digite um email válido.
      </h6>
      <h6 style="color:#bababa; font-size: 16px; font-weight: 400; opacity: 0.9;" *ngIf="email == ''">Preencha com
        seu email</h6>

        <p><input id="inputP2" class="myName" placeholder="Sua Data de Nascimento" type="text"
          [(ngModel)]="dataNascimento" name="fidade" mask="00/00/0000" (input)="calcularIdade()">
      </p>
      <h6 style="color:#ff0000aa; margin-bottom: 8px; font-size: 16px; font-weight: 400; opacity: 0.9;"
        *ngIf="idade != null && !isDataNascimentoValid()">
        Digite uma data de nascimento válida.
      </h6>
      <h6 style="color:#bababa; font-size: 16px; font-weight: 400; opacity: 0.9;margin-bottom: 10px;"
        *ngIf="dataNascimento == null">Preencha com
        sua Data de Nascimento</h6>

      <div class="realbs" style="float:right;">
        <button type="button" id="prevBtn" (click)="back()">
          <b>Voltar</b>
        </button>
        <button type="button" *ngIf="idade != null && isDataNascimentoValid() && cpfValid" id="nextBtn" class="realb"
          (click)="next()">
          <b class="real">Continuar</b>
        </button>
      </div>

    </div>
  </form>
</div>

<div id="wrapper2" *ngIf="tab == 2">


  <form id="regForm" hidden style="width: 45%;">
    <div id="container-progress" style="margin-bottom: 16px">
      {{ProgressBar(35)}}
      <div id="myProgress">
        <div id="myBar"></div>
        <ul class="ul-icons">
          <li id="circle1" class=" tooltip">
            <span class="tooltiptext">Sobre Você</span>
          </li>
          <li id="circle2" class=" tooltip">
            <span class="tooltiptext">Sobre seu projeto</span>
          </li>
          <li id="circle3" class=" tooltip">
            <span class="tooltiptext">Resultado da simulação</span>
          </li>
        </ul>
      </div>
    </div>
    <div class="tab">
      <small class="etapas">Pergunta 3 de 8</small>
      <p class="description-step"><span class="nome-pessoa"></span>{{nome}}, quais são seus planos ou projetos para o
        futuro?</p>

      <div class="metas">
        <div class="content-collapse-p3">
          <div oninput="this.className = ''" name="futuro" class="futuro sim pergunta3"
            [ngClass]="{'active' : checked1 == 1}" (click)="check1(1)">
            <h3>Educação</h3>
            <img src="./assets/education.png" alt="Imagem referente ao botão educação">
            <!-- <p>Poupar para receber uma renda de aposentadoria.</p> -->
          </div>
          <div oninput="this.className = ''" name="futuro" class="futuro sim pergunta3"
            [ngClass]="{'active' : checked1 == 2}" (click)="check1(2)">
            <h3>Sonho</h3>
            <img src="./assets/viagem.png" alt="Imagem referente ao botão viagem">

            <!-- <p>Abrir um negócio, fazer uma viagem, pagar uma faculdade, comprar um bem etc.</p> -->
          </div>
          <div oninput="this.className = ''" name="futuro" class="futuro sim pergunta3"
            [ngClass]="{'active' : checked1 == 3}" (click)="check1(3)">
            <h3>Construção de Patrimônio</h3>
            <img src="./assets/patrimonio.png" alt="Imagem referente ao botão construção de patrimônio">

            <!-- <p>Abrir um negócio, fazer uma viagem, pagar uma faculdade, comprar um bem etc.</p> -->
          </div>
          <div oninput="this.className = ''" name="futuro" class="futuro sim pergunta3"
            [ngClass]="{'active' : checked1 == 4}" (click)="check1(4)">
            <h3>Aposentadoria</h3>
            <img src="./assets/aposentadoria.png" alt="Imagem referente ao botão aposentadoria">

            <!-- <p>Abrir um negócio, fazer uma viagem, pagar uma faculdade, comprar um bem etc.</p> -->
          </div>
        </div>
      </div>
      <h6 style="color:#ff0000aa; margin-bottom: 10px; font-size: 16px; font-weight: 400; opacity: 0.9;"
        id="valid-checked1">
      </h6>

      <div class="realbs" style="float:right;">
        <button type="button" id="prevBtn" (click)="back()">
          <b>Voltar</b>
        </button>
        <button type="button" *ngIf="ok3" id="nextBtn" class="realb" (click)="next()">
          <b class="real">Continuar</b>
        </button>
      </div>

    </div>
  </form>
</div>

<div id="wrapper2" *ngIf="tab == 3">


  <form id="regForm" hidden style="width: 45%;">
    <div id="container-progress" style="margin-bottom: 16px">
      {{ProgressBar(63)}}
      <div id="myProgress">
        <div id="myBar"></div>
        <ul class="ul-icons">
          <li id="circle1" class=" tooltip">
            <span class="tooltiptext">Sobre Você</span>
          </li>
          <li id="circle2" class=" tooltip">
            <span class="tooltiptext">Sobre seu projeto</span>
          </li>
          <li id="circle3" class=" tooltip">
            <span class="tooltiptext">Resultado da simulação</span>
          </li>
        </ul>
      </div>
    </div>
    <div class="tab">
      <small class="etapas">Pergunta 4 de 8</small>
      <p class="description-step">Você sabe quanto precisa ter para realizar esse sonho?</p>
      <div oninput="this.className = ''" name="pj_vida">
        <!-- SE SIM -->
        <div>

          <div style="margin: 16px 0;">
            <button style="margin-right: 1rem;" type="button" class="qtdDinheiro sim pergunta4"
              [ngClass]="{'active' : checked2 == 2}" (click)="check2(2)">SIM</button>
            <button type="button" class="qtdDinheiro sim pergunta4" [ngClass]="{'active' : checked2 == 1}"
              (click)="check2(1)">NÃO</button>
          </div>

          <div class="content-collapse-p4" *ngIf="checked2 == 1 || checked2 == 2">
            <div class="content-sim-p4" *ngIf="checked2 == 2">
              <h3>Quanto?</h3>
              <div>
                <label>R$</label>
                <input id=" valor-sim-p4" class="valor-sim-p4" type="text" name="fp4sim" placeholder="Seu Valor"
                  currencyMask [(ngModel)]="pergunta4_sim"
                  [options]="{ prefix: '', thousands: '.', decimal: ',', align: 'left' }">
              </div>
              <h6 style="color:#ff0000aa; font-size: 16px; font-weight: 400; opacity: 0.9;" id="valid-sim-p4"
                *ngIf="pergunta4_sim < 500">
                O mínimo para este campo é de <strong>R$500,00</strong>.
              </h6>
            </div>
            <div class="content-nao-p4" *ngIf="checked2 == 1">
              <h3>Ok, {{nome}}! Quanto você pretende investir por mês?</h3>
              <div>
                <label>R$</label>
                <input id="valor-nao-p4" type="text" name="fp4nao" placeholder="Seu Valor" currencyMask
                  [(ngModel)]="pergunta4_nao" [options]="{ prefix: '', thousands: '.', decimal: ',', align: 'left' }">
              </div>
              <h6 style="color:#ff0000aa; font-size: 16px; font-weight: 400; opacity: 0.9;" id="valid-nao-p4"
                *ngIf="pergunta4_nao < 50">
                O mínimo para este campo é de <strong>R$50,00</strong>.
              </h6>
            </div>
          </div>
          <h6 style="color:#ff0000aa; margin-bottom: 10px; font-size: 16px; font-weight: 400; opacity: 0.9;"
            id="valid-checked2"></h6>
        </div>
      </div>
      <div class="realbs" style="float:right;">
        <button type="button" id="prevBtn" (click)="back()">
          <b>Voltar</b>
        </button>
        <button type="button" id="nextBtn" class="realb" (click)="next()"
          *ngIf="(pergunta4_sim != null && pergunta4_sim >= 500 && checked2 == 2) || (pergunta4_nao != null && pergunta4_nao >= 50 && checked2 == 1)">
          <b class="real">Continuar</b>
        </button>
      </div>
    </div>
  </form>
</div>


<div id="wrapper2" *ngIf="tab == 4">


  <form id="regForm" hidden style="width: 45%;">
    <div id="container-progress" style="margin-bottom: 16px">
      {{ProgressBar(73)}}
      <div id="myProgress">
        <div id="myBar"></div>
        <ul class="ul-icons">
          <li id="circle1" class=" tooltip">
            <span class="tooltiptext">Sobre Você</span>
          </li>
          <li id="circle2" class=" tooltip">
            <span class="tooltiptext">Sobre seu projeto</span>
          </li>
          <li id="circle3" class=" tooltip">
            <span class="tooltiptext">Resultado da simulação</span>
          </li>
        </ul>
      </div>
    </div>
    <div class="tab">
      <small class="etapas">Pergunta 5 de 8</small>
      <p class="description-step">Deseja fazer um investimento inicial para turbinar seu sonho?</p>
      <div oninput="this.className = ''" name="pj_vida">
        <div>
          <div style="margin: 16px 0;">
            <button style="margin-right: 1rem;" type="button" class="qtdDinheiro sim pergunta5"
              [ngClass]="{'active' : checked3 == 2}" (click)="check3(2)">SIM</button>
            <button type="button" class="qtdDinheiro sim pergunta5" [ngClass]="{'active' : checked3 == 1}"
              (click)="check3(1)" (click)="handleCheckClick(5)">NÃO</button>
          </div>
          <div class="content-collapse-p5" *ngIf="checked3 == 2">
            <div class="content-sim-p5">
              <h3>Quanto?</h3>
              <div>
                <label>R$</label>
                <input id="valor-sim-p5" class="valor-sim-p5" name="fp5sim" type="text" placeholder="Seu valor"
                  currencyMask [(ngModel)]="pergunta5_sim"
                  [options]="{ prefix: '', thousands: '.', decimal: ',', align: 'left' }">
              </div>
            </div>
            <h6 style="color:#ff0000aa; font-size: 16px; font-weight: 400; opacity: 0.9;" id="valid-sim-p5"
              *ngIf="pergunta5_sim <= 0">
              Por favor preencha seu valor
            </h6>
          </div>
          <span class="content-nao-p5"></span>
        </div>
        <h6 style="color:#ff0000aa;margin-bottom: 10px; font-size: 16px; font-weight: 400; opacity: 0.9;"
          id="valid-checked3">
        </h6>
      </div>
      <div class="realbs" style="float:right;">
        <button type="button" id="prevBtn" (click)="back()">
          <b>Voltar</b>
        </button>
        <button type="button" id="nextBtn" class="realb" (click)="next()"
          *ngIf="(checked3 == 2 && pergunta5_sim > 0) || (checked3 == 1) ">
          <b class="real">Continuar</b>
        </button>
      </div>
    </div>
  </form>
</div>


<div id="wrapper2" *ngIf="tab == 5">


  <form id="regForm" hidden style="width: 45%;">
    <div id="container-progress" style="margin-bottom: 16px">
      {{ProgressBar(83)}}
      <div id="myProgress">
        <div id="myBar"></div>
        <ul class="ul-icons">
          <li id="circle1" class=" tooltip">
            <span class="tooltiptext">Sobre Você</span>
          </li>
          <li id="circle2" class=" tooltip">
            <span class="tooltiptext">Sobre seu projeto</span>
          </li>
          <li id="circle3" class=" tooltip">
            <span class="tooltiptext">Resultado da simulação</span>
          </li>
        </ul>
      </div>
    </div>
    <div class="tab">
      <small class="etapas">Pergunta 6 de 8</small>
      <p class="description-step">Daqui a quanto tempo, você planeja realizar esse sonho?
      </p>
      <div oninput="this.className = ''" name="pj_vida">
        <div class="slidecontainer">
          <input type="range" min="3" max="50" value="3" class="slider" id="myRange" [(ngModel)]="anos" name="anos"
            style="width: 100%;">
          <div class="lineRanger"></div>
          <div style="text-align: center;">
            <h2 id="rangerValue" style="opacity: 0.8;"></h2>
            <h3 style="opacity: 0.8;">{{anos}} Anos</h3>
          </div>
        </div>
      </div>
      <div class="realbs" style="float:right;">
        <button type="button" id="prevBtn" (click)="back()">
          <b>Voltar</b>
        </button>
        <button type="button" id="nextBtn" class="realb" (click)="next()">
          <b class="real">Continuar</b>
        </button>
      </div>
    </div>
  </form>
</div>

<div id="wrapper2" *ngIf="tab == 6">


  <form id="regForm" hidden style="width: 45%;">

    <div id="container-progress" style="margin-bottom: 16px">
      {{ProgressBar(93)}}
      <div id="myProgress">
        <div id="myBar"></div>
        <ul class="ul-icons">
          <li id="circle1" class=" tooltip">
            <span class="tooltiptext">Sobre Você</span>
          </li>
          <li id="circle2" class=" tooltip">
            <span class="tooltiptext">Sobre seu projeto</span>
          </li>
          <li id="circle3" class=" tooltip">
            <span class="tooltiptext">Resultado da simulação</span>
          </li>
        </ul>
      </div>
    </div>
    <br>
    <div class="tab"> <small class="etapas">Pergunta 7 de 8</small>
      <p class="description-step">
        Por quantos anos você gostaria de receber sua renda?
      </p>
      <div oninput="this.className = ''" name="pj_vida">
        <div class="slidecontainer">
          <input type="range" min="5" value="5" max="50" class="slider" id="myRange2" [(ngModel)]="tempoRecebimento"
            name="tempoRecebimento" style="width: 100%;">
          <div class="lineRanger"></div>
          <div style="text-align: center;">
            <h2 id="rangerValue2" style="opacity: 0.8;"></h2>
            <h3 style="opacity: 0.8;">{{tempoRecebimento}} Anos</h3>
          </div>
        </div>
      </div>
      <div class="realbs" style="float:right;">
        <button type="button" id="prevBtn" (click)="back()">
          <b>Voltar</b>
        </button>
        <button type="button" id="nextBtn" class="realb" (click)="next()">
          <b class="real">Simular</b>
        </button>
      </div>
    </div>
  </form>
</div>


<div class="final" *ngIf="tab == 7">
  <div class="header-final">
    <h1 class="title-header">Transforme seu projeto em realidade!</h1>
    <div class="content-header-final">

      <div class="valor-avista">
        <div class="card-valor">
          <p>VALOR DO SONHO</p>
          <h1 id="valor-vista"><small>R$ </small>{{formatMoney(valorSimulacao)}}</h1>
        </div>
      </div>

      <div class="valor-parcelado">
        <div class="card-valor">
          <p>RENDA MENSAL POR {{tempoRecebimento}} ANOS</p>
          <h1 id="valor-parcelado"><small>R$ </small>{{formatMoney(valorParcelado)}}</h1>
        </div>
      </div>

    </div>
  </div>

  <div class="text-middle">
    <p>Esses são os valores que você simulou com {{idade}} anos de idade para uma contribuição de {{anos}}
      anos. Analise o resultado e, se quiser, altere os parâmetros abaixo.</p>
  </div>

  <div class="container-items">
    <div>
      <div class="card-item">
        <header>
          <span class="icon-container"></span>
          <h4 class="title-container">Contribuições mensais</h4>
          <span class="tolltip">?</span>
        </header>
        <div class="card-body">
          <h2 id="mensal"><small>R$ </small>{{ checked2 == 2 ? formatMoney(ctbSimulacao) : formatMoney(pergunta4_nao)}}
          </h2>
        </div>
        <input type="range" min="100" max="10000" value="0" id="cont-mensal" step="100" *ngIf="checked2 == 1"
          [(ngModel)]="pergunta4_nao" (input)="handleSimular()">

        <input type="range" min="100" max="10000" value="0" id="cont-mensal" step="100" *ngIf="checked2 != 1" disabled
          style="opacity: 0;" [(ngModel)]="pergunta4_nao" (input)="handleSimular()">

      </div>
      <div class="card-item">
        <header>
          <span class="icon-container"></span>
          <h4 class="title-container">Depósito Inicial</h4>
          <span class="tolltip">?</span>
        </header>
        <div class="card-body">
          <h2 id="dep"><small>R$ </small>{{pergunta5_sim ? formatMoney(pergunta5_sim) : "0,00"}}</h2>
        </div>
        <input type="range" min="0" max="1000000" value="0" id="deposito" step="5000" [(ngModel)]="pergunta5_sim"
          (input)="handleSimular()">
      </div>
    </div>
    <div>
      <div class="card-item">
        <header>
          <span class="icon-container"></span>
          <h4 class="title-container">Tempo de Contribuição</h4>
          <span class="tolltip">?</span>
        </header>
        <div class="card-body">
          <h2 id="tempo">{{anos}} Anos</h2>
        </div>
        <input type="range" min="3" max="50" value="0" id="tempo-cont" [(ngModel)]="anos" (input)="handleSimular()">
      </div>
      <div class="card-item">
        <header>
          <span class="icon-container"></span>
          <h4 class="title-container">Rentabilidade Anual Estimada</h4>
          <span class="tolltip">?</span>
        </header>
        <div class="card-body">
          <h2 id="rentabilidade">{{rentabilidade}} %</h2>
        </div>
        <input type="range" min="1" max="6" value="0" id="juros" [(ngModel)]="rentabilidade" (input)="handleSimular()">
      </div>
    </div>
    <div id="card-recebimento">
      <div class="card-item">
        <header>
          <span class="icon-container"></span>
          <h4 class="title-container">Tempo de Recebimento</h4>
          <span class="tolltip">?</span>
        </header>
        <div class="card-body">
          <h2 id="recebimento">{{tempoRecebimento}} Anos</h2>
        </div>
        <input type="range" min="5" max="50" value="0" id="rec" [(ngModel)]="tempoRecebimento"
          (input)="handleSimular()">
      </div>
    </div>
  </div>

  <div class="receber-email">
    <h2>Você gostaria de se cadastrar no nosso plano família?</h2>
    <br>
    <div>
      <form>
        <button type="button" class="qtdDinheiro" (click)="goToAdesao()">
          <span style="color: #6b6b6b; font-weight: 500;">Cadastre-se!</span>
        </button>
      </form>
    </div>
  </div>

  <div class="alert-container">
    <h4>Regras e parâmetros da simulação/rentabilidade</h4>
    <br />
    <p>Esta simulação não representa obrigação por parte da Previndus.</p>
    <p>Não há garantia de rentabilidade ou resultados futuros.</p>
    <p>O cálculo não inclui os descontos legais.</p>
    <p>A rentabilidade apresentada é líquida da taxa de administração, mas não desconta
      a variação da inflação.</p>
  </div>

  <div>
    <button (click)="novaSimulacao()" class="button-nova-simu">
      <h3>NOVA SIMULAÇÃO</h3>
    </button>
  </div>


  <div class="duvida">
    <header>
      <h3>Ficou com alguma dúvida?</h3>
      <p>Tem alguma dúvida ou precisa de orientação adicional? Envie uma mensagem para nós.</p>
    </header>
    <div class="help-other">
      <button class="help-other"><a href="mailto:familia@previndus.com.br" style="color: white;">FALE CONOSCO</a></button>
    </div>
  </div>
</div>


<footer>
  <p>Todos os direitos reservados. Desenvolvido por <strong><a href="#">TrustPrev</a></strong></p>
</footer>